// The Lab DEEP LINK (2026-10-08, user call: "beside the code I want the AI
// lab id in a param, so when they are logged in that lab response is
// opened"): `?lab=<entry id>` names a scripted answer of the session
// brand's pack (mock/lab — every entry carries a stable `id`). The URL
// grammar lives here, shared by the two places that read it:
//
//   - components/AuthGate forwards a link's `?lab=` to the session's Lab
//     page once the reader is in (`/?code=0441&lab=archive-bring-back` →
//     the wall → `/brands/tiffany/lab?lab=archive-bring-back`);
//   - pages/Lab reads the param on arrival and fires the entry's question
//     (the full think ledger, as a chip tap would), and MIRRORS every mock
//     answer it opens back into the param — so the address bar is the
//     share link (minus the code), and a refresh re-opens the answer.
//
// Unlike the code, the id is never scrubbed: it is not a secret, and a URL
// that names its answer is the point. An id is read only when it is
// slug-shaped (anything else is dropped as malformed, never thrown on).
export const LAB_PARAM = "lab";
const ID_SHAPE = /^[a-z0-9][a-z0-9-]{0,63}$/;

export const labPath = (slug) => `/brands/${slug}/lab`;
export const labSearch = (id) => (id ? `?${LAB_PARAM}=${id}` : "");
export const labUrl = (slug, id) => labPath(slug) + labSearch(id);

export const isLabId = (id) => typeof id === "string" && ID_SHAPE.test(id);

// the id a URL carries, or null (absent, or not an id at all)
export function readLabId(search) {
  const value = new URLSearchParams(search).get(LAB_PARAM);
  if (value == null) return null;
  const id = value.trim();
  return isLabId(id) ? id : null;
}

// the search without the lab param — "" or "?…", the rest kept in order
export function stripLabId(search) {
  const params = new URLSearchParams(search);
  params.delete(LAB_PARAM);
  const rest = params.toString();
  return rest ? `?${rest}` : "";
}
